import React, { useEffect } from "react";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import { connect } from "react-redux";
import Grid from '@mui/material/Grid';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import LoaderComponent from "../components/LoaderComponent";
import { loadEnumsGroupList } from "../api/enumsgroupapi";
import { getEnumsGroupList, getEnumsGroupLoading } from "../selector/selectors";
import { Link } from "react-router-dom";
import EnumsGroupComponent from "../components/EnumsGroupComponent";


function ManageEnumGroup({
  isLoading,
  enumsGroupList,
  startLoadingEnumsGroup,
}) {

    const [page, setPage]   = React.useState(0);
    const [value, setValue] = React.useState('1');
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    useEffect(() => {
      startLoadingEnumsGroup();
    }, [startLoadingEnumsGroup]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangePage = (event, pageVal) => {
        setPage(pageVal);
        startLoadingEnumsGroup(pageVal,rowsPerPage);
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
        startLoadingEnumsGroup(0,event.target.value);
    }

    return (
        <Box sx={{ flexGrow: 1 }} >
        { isLoading ?  <LoaderComponent />: <></>}
            <Grid container >
                <TabContext value={value}>
                    <Grid item xs={12} md={12} lg={12} >
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="">
                                <Link className="tabingLinks" to="/web/units">Units</Link>
                                <Link className="tabingLinks" to="/web/enums">Enums</Link>
                                <Tab label="Enum Groups" value="1" />
                            </TabList>
                        </Box>
                        <TabPanel value="1" sx={{p:0,pt:2}}>
                            <Grid container sx={{paddingBottom:2, display: 'flex', justifyContent: 'flex-end'}}>
                               
                            </Grid>
                            <EnumsGroupComponent filesList={enumsGroupList?.data} page={page} rowsPerPage={rowsPerPage} handleChangeRowsPerPage={handleChangeRowsPerPage} handleChangePage={handleChangePage} />
                        </TabPanel>
                    </Grid>
                </TabContext>
            </Grid>
        </Box>
    );
}

const mapStateToProps = (state) => ({
  isLoading: getEnumsGroupLoading(state),  
  enumsGroupList:getEnumsGroupList(state),  
});

const mapDispatchToProps = (dispatch) => ({
    startLoadingEnumsGroup: (page,rowsPerPage) => dispatch(loadEnumsGroupList(page,rowsPerPage)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageEnumGroup);

